








































































































































import Vue from "vue";

// vuex
import { mapActions, mapMutations, mapState } from "vuex";
import { RootState } from "@/store";
import * as a from "@/store/modules/InstallationsWorkloadModule/actions";
import * as m from "@/store/modules/InstallationsWorkloadModule/mutations";
import ColumnVisibilityFilter from "@/components/DataTableColumnVisibilityFilter/ColumnVisibilityFilter.vue";

// model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { formatCurrency } from "@/utility/Formatter";
import { InstallationWorkload } from "@/model/data/workload/InstallationWorkload";
import { DataOptions } from "vuetify";
import { GetWorkloadReqData } from "@/model/communication/workload/GetWorkloadReqData";
import { DownloadWorkloadReportCommand } from "@/model/communication/workload/DownloadWorkloadReportCommand";

export default Vue.extend({
    components: {
        ColumnVisibilityFilter,
    },
    data() {
        return {
            options: {},
            ignoreOptionsChanges: false,
            firstOptionsChange: true,
            dataTableItemsPerPage,
            downloadLoading: false,
            availableHeaders: [],
            initialAvailableHeaders: [
                {
                    enabled: true,
                    text: this.$t("common.name"),
                    value: "name",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("common.branch"),
                    value: "branch.name",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("common.tags"),
                    value: "tags",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("device_status.pc_name"),
                    value: "connectedPc",
                    sortable: false,
                },
                {
                    enabled: false,
                    text: this.$t("common.last_update"),
                    value: "lastMessage",
                    width: "120px",
                    sortable: false,
                },
                {
                    enabled: true,
                    text: this.$t("workloadReport.numberOfTransactions"),
                    value: "operationsCount",
                    align: "center",
                },
                {
                    enabled: true,
                    text: this.$t("workloadReport.banknotesQty"),
                    value: "banknotesQty",
                    align: "center",
                },
                {
                    enabled: true,
                    text: this.$t("workloadReport.coinsQty"),
                    value: "coinsQty",
                    align: "center",
                },
                {
                    text: "",
                    value: "divider",
                    width: "1",
                },
                {
                    enabled: true,
                    text: this.$t("workloadReport.cashIn"),
                    value: "currencyBalance.cashIn",
                },
                {
                    enabled: true,
                    text: this.$t("workloadReport.cashOut"),
                    value: "currencyBalance.cashOut",
                },
                {
                    enabled: true,
                    text: this.$t("workloadReport.balance"),
                    value: "currencyBalance.balance",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            installationsList: (state: RootState): InstallationWorkload[] => state.installationWorkload.installationsList,
            totalInstallationsCount: (state: RootState): number => state.installationWorkload.totalInstallationsCount,
            isInstallationsListFetching: (state: RootState): boolean => state.installationWorkload.isInstallationsListFetching,

            reqData: function (state: RootState): GetWorkloadReqData {
                return state.installationWorkload.reqData;
            },
        }),

        currentTableCurrency() {
            return this.installationsList != null && this.installationsList.length > 0 && this.installationsList[0].currencyBalance != null
                ? this.installationsList[0].currencyBalance.currency
                : "";
        },

        currenciesCombobox() {
            let res = [];
            this.currencies.forEach((c) => {
                let temp = {
                    id: res.length,
                    currency: c,
                };
                res.push(temp);
            });
            return res;
        },
    },
    watch: {
        reqData: {
            handler() {
                this[a.FETCH_INSTALLATIONS_WORKLOAD]();
            },
            deep: true,
        },
        options() {
            if (!this.ignoreOptionsChanges) {
                let currentOptions: DataOptions = this.options;

                let newReqData: GetWorkloadReqData = new GetWorkloadReqData(this.reqData);
                newReqData.offset = (currentOptions.page - 1) * currentOptions.itemsPerPage;
                newReqData.queryLimit = currentOptions.itemsPerPage;
                newReqData.orderBy = currentOptions.sortBy;
                newReqData.orderByDescending = currentOptions.sortDesc;

                this[m.SET_REQUEST_DATA](newReqData);
            } else this.ignoreOptionsChanges = false;
        },
    },
    methods: {
        ...mapActions([a.ON_PAGE_LOAD, a.FETCH_INSTALLATIONS_WORKLOAD]),
        ...mapMutations([m.SET_REQUEST_DATA]),
        formatCurrency,

        async exportAs(type) {
            this.downloadLoading = true;
            try {
                const res = await new DownloadWorkloadReportCommand(type, this.reqData).execute();

                let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                let fileLink = document.createElement("a");
                fileLink.href = fileURL;
                fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                document.body.appendChild(fileLink);
                fileLink.click();
                this.downloadLoading = false;
            } catch (e) {
                console.log("Something went wrong", e);
                this.downloadLoading = false;
            }
        },

        backToTheFirst() {
            if (this.options.page != 1) {
                this.ignoreOptionsChanges = true;
                this.options.page = 1;
                console.debug("backToTheFirst, this.options: ", this.options);
            }
        },
    },
    mounted() {
        let defaultReqData: GetWorkloadReqData = new GetWorkloadReqData(this.reqData);
        defaultReqData.queryLimit = this.dataTableItemsPerPage[0];
        this[m.SET_REQUEST_DATA](defaultReqData);
    },
});
